import React from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import VerticalDotDropdownToggle from '../bootstrap-extensions/VerticalDotDropdownToggle'

/**
 * Task data structure
 */
export interface ITask {
    id: number
    order: number
    name: string
    description: string
}

/**
 * Props passed to the Task component
 */
export interface ITaskProps {
    task: ITask
    onEdit: () => void
    onDelete: () => void
    onDragStart: (event: React.DragEvent) => void
    onDrop: (event: React.DragEvent) => void
    onDragEnter: (event: React.DragEvent) => void
    onDragOver: (event: React.DragEvent) => void
}

/**
 * Type guard for ITask.
 * If value is a ITask then true else false. All code after invocation will be considered
 * ITask if true.
 * @param value Item to check if is ITask
 */
function isITask(value: any | ITask): value is ITask {
    const Task = value as ITask
    return !(
        Task.id === undefined ||
        Task.order === undefined ||
        !Task.name ||
        !Task.description
    )
}

function TaskComponent(props: ITaskProps) {
    return (
        <div
            className="card shadow-sm"
            draggable
            aria-label="Task"
            onDragStart={props.onDragStart}
            onDrop={props.onDrop}
            onDragEnter={props.onDragEnter}
            onDragOver={props.onDragOver}>
            <div className="card-body">
                <h6 className="card-title">
                    <div className="d-flex">
                        <div className="flex-grow-1 align-self-center">
                            {props.task.name}
                        </div>
                        <div>
                            <Dropdown drop="left">
                                <Dropdown.Toggle
                                    as={VerticalDotDropdownToggle}
                                    className="text-primary"
                                />
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={props.onEdit}>
                                        Edit Task
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={props.onDelete}>
                                        Delete Task
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </h6>
                <p className="card-text">{props.task.description}</p>
            </div>
        </div>
    )
}

export { TaskComponent as default, isITask }
